import type { ReactNode } from 'react';
import { T } from '../lib/theme';

/**
 * A labelled form field: caption above, control below.
 *
 * Lifted out of `NewCoachSeriesPage` when the one-time coach form needed the
 * same layout (admin#47) — one definition rather than two forms drifting apart.
 *
 * `flex: 1 1 auto` (not `1 1 200px`) so the field hugs its content height when
 * placed in a column-flex container. `minWidth: 200` still enables graceful
 * wrapping when used inside row-flex container pairs (Table+Weekday, Times,
 * Dates).
 */
export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        flex: '1 1 auto',
        minWidth: 200,
      }}
    >
      <span style={T.label}>{label}</span>
      {children}
    </label>
  );
}
